// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2g2oY","list":"BalanceDue_list__1H-F3","listRow":"BalanceDue_listRow__1fzq9","total":"BalanceDue_total__7doVY"};